import { useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { X, Plus } from 'lucide-react';

/**
 * Multi-select de labels estilo GitLab.
 * catalog: [{ id, name, color, description? }]
 * value: string[] (ids o nombres libres)
 */
export default function LabelMultiSelect({ catalog = [], value = [], onChange, testId }) {
  const [draft, setDraft] = useState('');
  const [open, setOpen] = useState(false);

  const resolveLabel = (id) => {
    const found = catalog.find((l) => l.id === id || l.name === id);
    return found || { id, name: id, color: '#71717a' };
  };

  const add = (id) => {
    const v = (id || draft).trim();
    if (!v || value.includes(v)) return;
    onChange([...value, v]);
    setDraft('');
    setOpen(false);
  };

  const remove = (id) => onChange(value.filter((x) => x !== id));

  const available = catalog.filter((l) => !value.includes(l.id) && !value.includes(l.name));

  return (
    <div className="space-y-1" data-testid={testId}>
      <div className="flex flex-wrap gap-1 min-h-[28px]">
        {value.map((id) => {
          const lb = resolveLabel(id);
          return (
            <Badge
              key={id}
              className="text-[10px] rounded-sm px-2 py-0 gap-1 text-white border-0"
              style={{ backgroundColor: lb.color || '#71717a' }}
            >
              {lb.name || id}
              <button type="button" onClick={() => remove(id)} className="hover:opacity-70">
                <X className="w-2.5 h-2.5" />
              </button>
            </Badge>
          );
        })}
      </div>
      <div className="relative flex gap-1">
        <Input
          value={draft}
          onChange={(e) => { setDraft(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }}
          placeholder={catalog.length ? 'Agregar etiqueta...' : 'Etiqueta (texto libre)...'}
          className="h-8 text-xs rounded-sm flex-1"
        />
        <button
          type="button"
          onClick={() => add()}
          className="h-8 px-2 border border-brand-border rounded-sm text-zinc-500 hover:bg-zinc-50"
        >
          <Plus className="w-3 h-3" />
        </button>
        {open && (available.length > 0 || draft) && (
          <div className="absolute top-full left-0 right-0 z-50 mt-1 bg-white border border-brand-border rounded-sm shadow-lg max-h-36 overflow-auto">
            {available.map((l) => (
              <button
                key={l.id}
                type="button"
                className="w-full text-left px-3 py-1.5 text-xs hover:bg-zinc-50 flex items-center gap-2"
                onClick={() => add(l.id)}
              >
                <span className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: l.color }} />
                {l.name}
              </button>
            ))}
            {draft && !available.some((l) => l.id === draft || l.name === draft) && (
              <button
                type="button"
                className="w-full text-left px-3 py-1.5 text-xs hover:bg-zinc-50 text-zinc-500"
                onClick={() => add()}
              >
                Crear &quot;{draft}&quot;
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
